import React, { ReactElement } from "react";

import { IconSvg } from "../../icon/icon-svg";

export const IconThumbDown = ({ ...svgAttrs }): ReactElement => (
  <IconSvg {...svgAttrs}>
    <path
      d="M3.54545 5.7599C2.94327 5.7599 2.45455 5.27117 2.45455 4.66899C2.45455 4.06754 2.94327 3.57808 3.54545 3.57808H4.27273C3.67055 3.57808 3.18182 3.08936 3.18182 2.48717C3.18182 1.88572 3.67055 1.39626 4.27273 1.39626H9C11.9091 1.39626 11.1818 2.75626 17 2.75626V9.39627H14.8182C12.2727 9.39627 9.36364 11.6915 9.36364 15.1679C9.36364 16.3192 7.18182 16.4864 7.18182 14.3046C7.18182 12.8501 7.90909 10.1235 7.90909 10.1235H2.09091C1.48873 10.1235 1 9.63481 1 9.03263C1 8.43117 1.48873 7.94172 2.09091 7.94172H2.81818C2.216 7.94172 1.72727 7.45299 1.72727 6.85081C1.72727 6.24936 2.216 5.7599 2.81818 5.7599H3.54545Z"
      stroke="#121315"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconSvg>
);
